export default function VoltTrailsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="vt-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2F86EA" />
          <stop offset="1" stopColor="#BFE6FA" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="12" fill="url(#vt-sky)" />
      <circle cx="50" cy="13" r="5" fill="#FFF3C4" />
      <path d="M-2 44Q14 34 30 42T66 38V64H-2Z" fill="#4FA83E" />
      <path d="M-2 52Q20 44 38 52T66 50V64H-2Z" fill="#3E9332" />
      <path d="M6 64Q22 50 40 54Q52 57 66 52V64Z" fill="#B57A48" />
      <path d="M8 40L12 30L16 40Z M16 41L20 28L24 41Z" fill="#1E7044" />
      <g transform="rotate(-32 30 44)">
        <circle cx="19" cy="46" r="7" fill="none" stroke="#22252E" strokeWidth="3.4" />
        <circle cx="41" cy="46" r="7" fill="none" stroke="#22252E" strokeWidth="3.4" />
        <path d="M19 46L27 38L37 38L41 46" stroke="#AEB5C2" strokeWidth="2.4" fill="none" strokeLinejoin="round" />
        <rect x="24" y="33" width="11" height="7" rx="2" fill="#FFD23F" stroke="#1E2433" strokeWidth="1.2" />
        <path d="M30 34.2l-2.4 3h2l-.8 2 2.6-3h-2Z" fill="#1E2433" />
        <path d="M37 38L39 30" stroke="#2B2F3A" strokeWidth="2.6" strokeLinecap="round" />
        <path d="M36 30h6" stroke="#2B2F3A" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M18 34h9" stroke="#1E2433" strokeWidth="3" strokeLinecap="round" />
        <path d="M26 34L30 24L38 30" stroke="#2F6BFF" strokeWidth="4.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M26 34l3 6" stroke="#2A2F45" strokeWidth="3.6" strokeLinecap="round" />
        <circle cx="31" cy="20" r="4.6" fill="#F4F6FA" stroke="#1E2433" strokeWidth="1.3" />
        <rect x="31" y="18.4" width="4.6" height="2.4" rx="1" fill="#2A3550" />
      </g>
      <path d="M50 30l-4 6h3l-1.5 5 5-7h-3l1.5-4Z" fill="#FFD23F" stroke="#7A4A00" strokeWidth="1" strokeLinejoin="round" />
    </svg>
  );
}
